import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FileService } from '../../services/file/file.service';

@Component({
  selector: 'bom-download-file',
  templateUrl: './download-file.component.html',
  styleUrls: ['./download-file.component.scss'],
})
export class DownloadFileComponent {
  @Input()
  displayText: string;

  @Input()
  fileName: string;

  @Input()
  url: string;

  @Input()
  params: any;

  @Input()
  tooltipText: string;

  isDownloading$ = new BehaviorSubject<boolean>(false);

  constructor(private fileService: FileService) {}

  downloadFile() {
    if (this.isDownloading$.value) {
      return;
    }

    this.isDownloading$.next(true);
    this.fileService.download(this.fileName, this.url, this.params).subscribe({
      next: () => {
        this.isDownloading$.next(false);
      },
      error: err => {
        this.isDownloading$.next(false);
        throw err;
      },
    });
  }
}
